class WishlistButton extends HTMLElement {
  constructor() {
    super();
    // this.attachShadow({ mode: 'open' });
    this.productId = this.getAttribute("product");
  }

  connectedCallback() {
    this.updateStatus();
    this.addEventListener("click", () => this.toggleWishlist());
  }

  toggleWishlist() {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const itemIndex = wishlist.indexOf(this.productId);

    if (itemIndex === -1) {
      wishlist.push(this.productId);
    } else {
      wishlist.splice(itemIndex, 1);
    }

    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    this.updateStatus();
    this.updateLinkedButtons();
    document
      .querySelectorAll("wishlist-counter")
      .forEach((counter) => counter.updateCounter());
  }

  updateStatus() {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const inWishlist = wishlist.includes(this.productId);

    if (inWishlist) {
      this.classList.add("active");
    } else {
      this.classList.remove("active");
    }
  }

  updateLinkedButtons() {
    document
      .querySelectorAll(`wishlist-button[product="${this.productId}"]`)
      .forEach((button) => button.updateStatus());
  }
}

class WishlistCounter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateCounter();
  }

  updateCounter() {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    if (wishlist.length > 0) {
      this.innerHTML = wishlist.length;
    } else {
      this.innerHTML = "";
    }
  }
}

class WishlistProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadWishlistProducts();
  }

  async loadWishlistProducts() {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const domain = window.location.origin; // Adjust domain if necessary
    const productContainer = this;
    const initalHtml = this.innerHTML;

    if (wishlist.length === 0) {
      return;
    } else {
      productContainer.innerHTML = "";
    }

    const validProducts = [];

    for (const productId of wishlist) {
      fetch(`${domain}/products/${productId}?view=grid-item`)
        .then((response) => {
          if (!response.ok) {
            this.removeFromWishlist(productId);
            throw new Error("Network response was not ok");
          }
          return response.text();
        })
        .then(function (html) {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;

          const productItem = tempDiv.querySelector("div.product-item");
          if (productItem) {
            productContainer.appendChild(productItem);
            validProducts.push(productId);
          } else {
            this.removeFromWishlist(productId);
          }
        });
    }
  }

  removeFromWishlist(productId) {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const itemIndex = wishlist.indexOf(productId);
    wishlist.splice(itemIndex, 1);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    document
      .querySelectorAll("wishlist-counter")
      .forEach((counter) => counter.updateCounter());
  }
}

// Register the custom element
customElements.define("wishlist-button", WishlistButton);
customElements.define("wishlist-counter", WishlistCounter);
customElements.define("wishlist-products", WishlistProducts);
